import React from 'react';
import {MasterLayout} from 'components/layouts';
import {SendComplaintContainer} from 'components/users';
import MemberZone from './MemberZone.jsx'
import title from 'constants/TitlePages.js';

class SendComplaint extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.SendComplaint;
  }

  render() {
    return (
      <MasterLayout>
        <SendComplaintContainer/>
      </MasterLayout>
    );
  }
}

export default MemberZone(SendComplaint);



// WEBPACK FOOTER //
// ./pages/users/SendComplaint.jsx